import React from 'react';
import { motion } from 'framer-motion';
export function BookMockup() {
  return <motion.div initial={{
    opacity: 0,
    y: 30,
    scale: 0.95
  }} animate={{
    opacity: 1,
    y: 0,
    scale: 1
  }} transition={{
    duration: 1,
    ease: 'easeOut'
  }} className="relative w-72 sm:w-96 lg:w-[440px] mx-auto" data-id="element-13">
      {/* Ambient glow */}
      <div className="absolute inset-0 -z-10 bg-brand-gold/10 blur-3xl rounded-full scale-90" data-id="element-14" />

      <motion.img src="https://cdn.magicpatterns.com/uploads/tnvaJ6wjwBU3oDgHLbaM5K/otro.png" alt="El Código Maestro - Protocolo de 30 días con bonus incluidos" className="w-full h-auto object-contain drop-shadow-[0_25px_45px_rgba(0,0,0,0.6)]" animate={{
      y: [0, -8, 0]
    }} transition={{
      duration: 5,
      repeat: Infinity,
      ease: 'easeInOut'
    }} data-id="element-15" />
    </motion.div>;
}